module.exports = {"361104001":"旭日街道","361104002":"罗桥街道","361104003":"兴园街道","361104101":"田墩镇","361104102":"上泸镇","361104103":"华坛山镇","361104104":"茶亭镇","361104105":"皂头镇","361104106":"四十八镇","361104107":"枫岭头镇","361104108":"煌固镇","361104109":"花厅镇","361104110":"五府山镇","361104111":"郑坊镇","361104200":"望仙乡","361104201":"石人乡","361104202":"清水乡","361104203":"石狮乡","361104204":"湖村乡","361104207":"尊桥乡","361104209":"应家乡","361104210":"黄沙岭乡","361104211":"铁山乡","361104290":"董团乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/361104.json
// module id = 1455
// module chunks = 0